import "./App.css";
import AiChat from "./components/ai/Ai";

function App() {
  return (
    <div className="App">
      <AiChat />
    </div>
  );
}

export default App;
